import {
  BookOpen,
  Code,
  File,
  FileText,
  Folder,
  HelpCircle,
  type LucideIcon,
  Newspaper,
  Presentation,
  ScrollText,
  Tag,
  Video,
} from "lucide-react";

import type { DocType } from "./types.js";

/**
 * The icon vocabulary of the Documentation section, resolved in one place.
 *
 * A folder's `icon` is the name portal-api seeds ("book", "help-circle",
 * "file-text", …) — lucide's own names, so the map below is a lookup and
 * not a guess; anything unknown, or null, is a plain folder. An article's
 * icon follows its `doc_type` so a video and a FAQ read differently in a
 * list before the title is read.
 */
const CATEGORY_ICONS: Record<string, LucideIcon> = {
  book: BookOpen,
  code: Code,
  tag: Tag,
  video: Video,
  "help-circle": HelpCircle,
  scroll: ScrollText,
  "file-text": FileText,
  presentation: Presentation,
  newspaper: Newspaper,
  folder: Folder,
};

export function categoryIcon(icon: string | null | undefined): LucideIcon {
  return (icon && CATEGORY_ICONS[icon]) || Folder;
}

const DOC_TYPE_ICONS: Record<DocType, LucideIcon> = {
  article: FileText,
  guide: BookOpen,
  video: Video,
  faq: HelpCircle,
  slide: Presentation,
  file: File,
};

export function docTypeIcon(type: DocType): LucideIcon {
  return DOC_TYPE_ICONS[type] ?? FileText;
}
